export default __webpack_public_path__ + "static/media/logo.53104a3c.png";